import Vector2d from '../engine/vector2d';
import Entity from '../entity';
import State from '../state';
import { ChaseMode, Ghost } from './ghost';

export default class Pinky extends Ghost {

  getSpriteOffset(): number {
    return 1;
  }

  getGhost(state: State): Entity {
    const [pinky] = state.ghosts.filter(g => g.name === 'pinky');
    return pinky;
  }

  getTarget(mode: ChaseMode, state: State): Vector2d {
    switch (mode) {
      case ChaseMode.Chase:
      case ChaseMode.Frightened:
        return this.getClosestTarget(state);
    }

    return this.getGhost(state).position;
  }
}
